import { render, staticRenderFns } from "./CLtkImg.vue?vue&type=template&id=17367470"
import script from "./CLtkImg.vue?vue&type=script&lang=ts"
export * from "./CLtkImg.vue?vue&type=script&lang=ts"
import style0 from "./CLtkImg.vue?vue&type=style&index=0&id=17367470&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CImage: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/components/CImage/CImage.vue').default})
